import styled from 'styled-components';
import { ColorAddiBackgroundWhite } from '@addi/foundation/dist/web/colors';
export const InfoContainer = styled.div `
  padding: ${({ spacingReduction }) => (spacingReduction ? '10px 15px 0' : '10px 15px')};
`;
export const InfoContent = styled.div `
  width: auto;
  height: fit-content;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ spacingReduction }) => (spacingReduction ? '10px 15px 0' : '10px 15px')};
  background-color: ${({ backgroundColor }) => backgroundColor ? backgroundColor : ColorAddiBackgroundWhite};
  box-shadow: ${({ spacingReduction }) => spacingReduction
    ? 'none'
    : '0px 1px 32px rgba(177, 218, 255, 0.16), 0px 12px 24px rgba(99, 148, 255, 0.12)'};
`;
export const IconContainer = styled.div `
  margin: 5px 0;
`;
//# sourceMappingURL=loan-info-card.styled.js.map